import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ClientPaymentTokenStatus } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'payment-token-status',
  templateUrl: './payment-token-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class PaymentTokenStatusComponent {
  private readonly cd = inject(ChangeDetectorRef);

  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  getClientPaymentTokenStatus(value: any) {
    const capitalizedValue = ClientPaymentTokenStatus[value]
      ? ClientPaymentTokenStatus[value].toString().charAt(0).toUpperCase() +
        ClientPaymentTokenStatus[value].toString().slice(1)
      : '-';
    return capitalizedValue || '-';
  }
}
